var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid p-0 mt-0" },
    [
      _vm._t("message"),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-3 col-lg-3" },
          [
            _c("omegaup-user-maininfo", {
              attrs: {
                profile: _vm.profile,
                data: _vm.data,
                "selected-tab": _vm.currentSelectedTab,
                "has-password": _vm.hasPassword
              },
              on: {
                "update:selectedTab": function($event) {
                  _vm.currentSelectedTab = $event
                },
                "update:selected-tab": function($event) {
                  _vm.currentSelectedTab = $event
                }
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-md-9 col-lg-9 sticky-top" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [_vm._t("title")], 2),
            _c("div", { staticClass: "card-body" }, [_vm._t("content")], 2)
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }